import $i18n from '@/locales/i18n';
import { createBlockInitialChildrenSnippet } from '@/common/manager/setter-snippet';
import { getCurrentBlockInfo, insertNewBlock } from '@/common/util/block';
import View from './view';
import './view.scss';
const isMobile = window.cnLowcodeStore?.page?.pageSubtype === 'MOBILE';
const { CnTooltip } = window?.CNUI || {};
const CnLayoutBlockProto = (props) => {
    const needDesignHandle = !isMobile;
    const currentBlockInfo = getCurrentBlockInfo({ _nodeId: props?._nodeId, _leaf: props?._leaf });
    const addIcon = (<div onClick={() => {
            insertNewBlock({
                currentBlockInfo,
                _leaf: props?._leaf,
            });
        }} className="cn-layout-block-design-tool-insert"/>);
    const addCard = () => {
        const { _leaf } = props || {};
        _leaf.insertAfter?.(createBlockInitialChildrenSnippet({
            cardProps: {
                title: $i18n.get({ id: 'Title', dm: '标题' }),
            },
        }));
    };
    return (<View {...props} className="cn-layout-block-relative" extraDom={<>
          {needDesignHandle && (<div className={'cn-layout-block-design-tool'}>
              <div className="cn-layout-block-design-tool-drag"/>
              {CnTooltip ? (<CnTooltip v2 align="t" trigger={addIcon}>
                  {$i18n.get({ id: 'InsertNewColumn', dm: '插入新栏' })}
                </CnTooltip>) : (addIcon)}
            </div>)}
          {props?.children?.[0]?.props?.children?.includes('拖拽组件') ? (<div className="cn-layout-block-add-card">
              <div onClick={addCard} className="cn-layout-block-add-card-btn">
                {$i18n.get({ id: 'ClickToQuicklyAddCards', dm: '点击快速添加卡片' })}
              </div>
            </div>) : null}
        </>}/>);
};
CnLayoutBlockProto.typeMark = 'Block';
CnLayoutBlockProto.displayName = 'CnLayoutBlock';
export default CnLayoutBlockProto;
